import gsap from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

(function () {
	gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

	var animShapesElements = document.getElementsByClassName('js-anim-shape');
	var animShapes = Array.from(animShapesElements);

	shapeInViewportCheck();

	document.addEventListener('scroll', shapeInViewportCheck, {
		passive: true,
	});

	function shapeInViewportCheck() {
		for (var i = 0; i < animShapes.length; i++) {
			var rect = animShapes[i].getBoundingClientRect(),
				topOffset = 0,
				bottomOffset = 0,
				distanceFromTop = window.pageYOffset + rect.top,
				distanceFromBottom =
					document.body.scrollHeight -
					(window.pageYOffset + rect.bottom),
				clientHeight = document.documentElement.clientHeight;

			if (distanceFromTop < clientHeight) {
				topOffset = Math.ceil(clientHeight - distanceFromTop);
			}

			if (distanceFromBottom < clientHeight) {
				bottomOffset = Math.ceil(clientHeight - distanceFromBottom);
			}

			if (rect.top - clientHeight <= 0) {
				// @ts-ignore-next
				initShapeAnimation(animShapes[i], topOffset, bottomOffset);
				animShapes.splice(i, 1);
				i -= 1;
			}
		}
	}

	function initShapeAnimation(
		el: HTMLElement,
		topOffset: number,
		bottomOffset: number
	) {
		var animType = el.dataset.animType;
		if (!animType) {
			return;
		}
		switch (animType) {
			case 'rotated-shape':
				initRotatedShapeAnimation(el, topOffset, bottomOffset);
				break;
			case 'rotated-shape-2':
				initRotatedShapeAnimation2(el, topOffset, bottomOffset);
				break;
			case 'rotated-shape-3':
				initRotatedShapeAnimation3(el, topOffset, bottomOffset);
				break;
			case 'rotated-shape-3-inv':
				initRotatedShapeAnimation3Inverted(el, topOffset, bottomOffset);
				break;
			case 'rotated-shape-4':
				initRotatedShapeAnimation4(el, topOffset, bottomOffset);
				break;
			case 'rotated-shape-5':
				initRotatedShapeAnimation5(el, topOffset, bottomOffset);
				break;
			case 'moving-ball-angle':
				initMovingBallsInAngleAnimation(el, topOffset, bottomOffset);
				break;
			case 'moving-ball-angle-inv':
				initMovingBallsInAngleInvertedAnimation(
					el,
					topOffset,
					bottomOffset
				);
				break;
			case 'moving-ball-square':
				initMovingBallsInSquareAnimation(el, topOffset, bottomOffset);
				break;
			case 'moving-ball-square-inv':
				initMovingBallsInSquareInvertedAnimation(
					el,
					topOffset,
					bottomOffset
				);
				break;
			case 'rotated-shape-noscroll':
				initRotatedShapeAnimationNoscroll(el);
				break;
			case 'rotated-shape-2-noscroll':
				initRotatedShapeAnimation2Noscroll(el);
				break;
			case 'moving-ball-angle-noscroll':
				initMovingBallsInAngleAnimationNoscroll(el);
				break;
			case 'moving-ball-angle-inv-noscroll':
				initMovingBallsInAngleInvertedAnimationNoscroll(el);
				break;
			case 'moving-ball-square-noscroll':
				initMovingBallsInSquareAnimationNoscroll(el);
				break;
			case 'moving-ball-square-inv-noscroll':
				initMovingBallsInSquareInvertedAnimationNoscroll(el);
				break;
		}
	}

	function initRotatedShapeAnimation(
		el: HTMLElement,
		topOffset: number,
		bottomOffset: number
	) {
		gsap.to(el, {
			rotation: -180,
			duration: 2,
			transformOrigin: '131px 166px',
			ease: 'linear',
			scrollTrigger: {
				trigger: el,
				start: !topOffset
					? 'top bottom'
					: 'top bottom-=' + topOffset + 'px',
				end: !bottomOffset
					? 'bottom top'
					: 'bottom top+=' + bottomOffset + 'px',
				scrub: 0,
				markers: false,
			},
		});
	}

	function initRotatedShapeAnimation2(
		el: HTMLElement,
		topOffset: number,
		bottomOffset: number
	) {
		gsap.to(el, {
			rotation: -180,
			duration: 2,
			transformOrigin: '131px 165px',
			ease: 'linear',
			scrollTrigger: {
				trigger: el,
				start: !topOffset
					? 'top bottom'
					: 'top bottom-=' + topOffset + 'px',
				end: !bottomOffset
					? 'bottom top'
					: 'bottom top+=' + bottomOffset + 'px',
				scrub: 0,
				markers: false,
			},
		});
	}

	function initRotatedShapeAnimation3(
		el: HTMLElement,
		topOffset: number,
		bottomOffset: number
	) {
		gsap.to(el, {
			rotation: 180,
			duration: 2,
			transformOrigin: '50% 90%',
			ease: 'linear',
			scrollTrigger: {
				trigger: el,
				start: !topOffset
					? 'top bottom'
					: 'top bottom-=' + topOffset + 'px',
				end: !bottomOffset
					? 'bottom top'
					: 'bottom top+=' + bottomOffset + 'px',
				scrub: 0,
				markers: false,
			},
		});
	}

	function initRotatedShapeAnimation3Inverted(
		el: HTMLElement,
		topOffset: number,
		bottomOffset: number
	) {
		gsap.to(el, {
			rotation: -180,
			duration: 2,
			transformOrigin: '50% 87%',
			ease: 'linear',
			scrollTrigger: {
				trigger: el,
				start: !topOffset
					? 'top bottom'
					: 'top bottom-=' + topOffset + 'px',
				end: !bottomOffset
					? 'bottom top'
					: 'bottom top+=' + bottomOffset + 'px',
				scrub: 0,
				markers: false,
			},
		});
	}

	function initRotatedShapeAnimation4(
		el: HTMLElement,
		topOffset: number,
		bottomOffset: number
	) {
		gsap.to(el, {
			rotation: -180,
			duration: 2,
			transformOrigin: '50% 82.4427%',
			ease: 'linear',
			scrollTrigger: {
				trigger: el,
				start: !topOffset
					? 'top bottom'
					: 'top bottom-=' + topOffset + 'px',
				end: !bottomOffset
					? 'bottom top'
					: 'bottom top+=' + bottomOffset + 'px',
				scrub: 0,
				markers: false,
			},
		});
	}

	function initRotatedShapeAnimation5(
		el: HTMLElement,
		topOffset: number,
		bottomOffset: number
	) {
		gsap.to(el, {
			rotation: 180,
			duration: 2,
			transformOrigin: '118px 148px',
			ease: 'linear',
			scrollTrigger: {
				trigger: el,
				start: !topOffset
					? 'top bottom'
					: 'top bottom-=' + topOffset + 'px',
				end: !bottomOffset
					? 'bottom top'
					: 'bottom top+=' + bottomOffset + 'px',
				scrub: 0,
				markers: false,
			},
		});
	}

	function initMovingBallsInAngleAnimation(
		el: HTMLElement,
		topOffset: number,
		bottomOffset: number
	) {
		var shape = el.querySelector('.js-anim-shape__shape'),
			path = el.querySelector('.js-anim-shape__path');

		if (shape === null || path === null) {
			return;
		}

		if (path instanceof SVGPathElement) {
			gsap.to(shape, {
				duration: 10,
				motionPath: {
					path: path,
					align: path,
					alignOrigin: [0.5, 0.5],
				},
				scrollTrigger: {
					trigger: el,
					start: !topOffset
						? 'top bottom'
						: 'top bottom-=' + topOffset + 'px',
					end: !bottomOffset
						? 'bottom top'
						: 'bottom top+=' + bottomOffset + 'px',
					scrub: 0,
					markers: false,
				},
			});
		}
	}

	function initMovingBallsInAngleInvertedAnimation(
		el: HTMLElement,
		topOffset: number,
		bottomOffset: number
	) {
		var shape = el.querySelector('.js-anim-shape__shape'),
			path = el.querySelector('.js-anim-shape__path');

		if (shape === null || path === null) {
			return;
		}

		if (path instanceof SVGPathElement) {
			gsap.to(shape, {
				duration: 10,
				motionPath: {
					path: path,
					align: path,
					alignOrigin: [0.5, 0.5],
					start: 1,
					end: 0,
				},
				scrollTrigger: {
					trigger: el,
					start: !topOffset
						? 'top bottom'
						: 'top bottom-=' + topOffset + 'px',
					end: !bottomOffset
						? 'bottom top'
						: 'bottom top+=' + bottomOffset + 'px',
					scrub: 0,
					markers: false,
				},
			});
		}
	}

	function initMovingBallsInSquareAnimation(
		el: HTMLElement,
		topOffset: number,
		bottomOffset: number
	) {
		var shape = el.querySelector('.js-anim-shape__shape'),
			path = el.querySelector('.js-anim-shape__path');

		topOffset -= 500;

		if (shape === null || path === null) {
			return;
		}

		if (path instanceof SVGPathElement) {
			gsap.to(shape, {
				duration: 1,
				motionPath: {
					path: path,
					align: path,
					alignOrigin: [0.5, 0.5],
				},
				scrollTrigger: {
					trigger: el,
					start: !topOffset
						? 'top bottom'
						: topOffset > 0
						? 'top bottom+=' + topOffset + 'px'
						: 'top bottom-=' + topOffset + 'px',
					end: !bottomOffset
						? 'bottom top'
						: 'bottom top+=' + bottomOffset + 'px',
					scrub: 0,
					markers: false,
				},
			});
		}
	}

	function initMovingBallsInSquareInvertedAnimation(
		el: HTMLElement,
		topOffset: number,
		bottomOffset: number
	) {
		var shape = el.querySelector('.js-anim-shape__shape'),
			path = el.querySelector('.js-anim-shape__path');

		topOffset -= 500;

		if (shape === null || path === null) {
			return;
		}

		if (path instanceof SVGPathElement) {
			gsap.to(shape, {
				duration: 1,
				motionPath: {
					path: path,
					align: path,
					alignOrigin: [0.5, 0.5],
					start: 1,
					end: 0,
				},
				scrollTrigger: {
					trigger: el,
					start: !topOffset
						? 'top bottom'
						: topOffset > 0
						? 'top bottom+=' + topOffset + 'px'
						: 'top bottom-=' + topOffset + 'px',
					end: !bottomOffset
						? 'bottom top'
						: 'bottom top+=' + bottomOffset + 'px',
					scrub: 0,
					markers: false,
				},
			});
		}
	}

	function initRotatedShapeAnimationNoscroll(el: HTMLElement) {
		gsap.to(el, {
			rotation: 180,
			duration: 2.5,
			transformOrigin: '131px 166px',
			ease: 'ease',
			scrollTrigger: {
				trigger: el,
				start: 'top bottom',
				markers: false,
			},
		});
	}

	function initRotatedShapeAnimation2Noscroll(el: HTMLElement) {
		gsap.to(el, {
			rotation: -180,
			duration: 2.5,
			transformOrigin: '131px 165px',
			ease: 'ease',
			scrollTrigger: {
				trigger: el,
				start: 'top bottom',
				markers: false,
			},
		});
	}

	function initMovingBallsInAngleAnimationNoscroll(el: HTMLElement) {
		var shape = el.querySelector('.js-anim-shape__shape'),
			path = el.querySelector('.js-anim-shape__path');

		if (shape === null || path === null) {
			return;
		}

		if (path instanceof SVGPathElement) {
			gsap.to(shape, {
				duration: 2,
				ease: 'ease',
				motionPath: {
					path: path,
					align: path,
					alignOrigin: [0.5, 0.5],
				},
				scrollTrigger: {
					trigger: el,
					start: 'top bottom',
					markers: false,
				},
			});
		}
	}

	function initMovingBallsInAngleInvertedAnimationNoscroll(el: HTMLElement) {
		var shape = el.querySelector('.js-anim-shape__shape'),
			path = el.querySelector('.js-anim-shape__path');

		if (shape === null || path === null) {
			return;
		}

		if (path instanceof SVGPathElement) {
			gsap.to(shape, {
				duration: 2,
				ease: 'ease',
				motionPath: {
					path: path,
					align: path,
					alignOrigin: [0.5, 0.5],
					start: 1,
					end: 0,
				},
				scrollTrigger: {
					trigger: el,
					start: 'top bottom',
					markers: false,
				},
			});
		}
	}

	function initMovingBallsInSquareAnimationNoscroll(el: HTMLElement) {
		var shape = el.querySelector('.js-anim-shape__shape'),
			path = el.querySelector('.js-anim-shape__path');

		if (shape === null || path === null) {
			return;
		}

		if (path instanceof SVGPathElement) {
			gsap.to(shape, {
				duration: 4,
				ease: 'ease',
				motionPath: {
					path: path,
					align: path,
					alignOrigin: [0.5, 0.5],
				},
				scrollTrigger: {
					trigger: el,
					start: 'top bottom',
					markers: false,
				},
			});
		}
	}

	function initMovingBallsInSquareInvertedAnimationNoscroll(el: HTMLElement) {
		var shape = el.querySelector('.js-anim-shape__shape'),
			path = el.querySelector('.js-anim-shape__path');

		if (shape === null || path === null) {
			return;
		}

		if (path instanceof SVGPathElement) {
			gsap.to(shape, {
				duration: 4,
				ease: 'ease',
				motionPath: {
					path: path,
					align: path,
					alignOrigin: [0.5, 0.5],
					start: 1,
					end: 0,
				},
				scrollTrigger: {
					trigger: el,
					start: 'top bottom',
					markers: false,
				},
			});
		}
	}
})();
